/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityGroupCreateRequest } from '../../models/facility-group-create-request';
import { FacilityGroupResponse } from '../../models/facility-group-response';

export interface CreateFacilityGroup$Params {
      body: FacilityGroupCreateRequest
}

export function createFacilityGroup(http: HttpClient, rootUrl: string, params: CreateFacilityGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityGroupResponse>> {
  const rb = new RequestBuilder(rootUrl, createFacilityGroup.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FacilityGroupResponse>;
    })
  );
}

createFacilityGroup.PATH = '/api/facilitygroup';
